import { Component, OnInit } from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-selete-hospital',
  templateUrl: './selete-hospital.component.html',
  styleUrls: ['./selete-hospital.component.scss']
})
export class SeleteHospitalComponent implements OnInit {
  role = localStorage.getItem('role')
  hospital = JSON.parse(localStorage.getItem('hospital'))
  hospital_id = localStorage.getItem('hospital_id')
  hospital_selete = new FormControl('', [Validators.required]);
  pre_diagnosis_selete = new FormControl([]);
  pre_diagnosis_defaults = new FormControl([], [Validators.required]);
  // hospitals = ['โรงพยาบาลเทพหรั่ง', 'โรงพยาบาลเฮียหมู'];
  hospitals: any
  pre_diagnosis_default = ['Tuberculosis','Abnormal']
  pre_diagnosis: any
  data: any = {}

  // api
  hospitalAPI = `${environment.apiUrl}/hospitalpackage?hospital_id=${this.hospital_id}`;
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    private router: Router,
    private http: HttpClient,
  ) { 
  }

  ngOnInit() {
    // this.getHospital()
    this.hospital_selete.setValue(this.hospital)
    this.hospital_selete.disable()
    this.pre_diagnosis_defaults.setValue(this.pre_diagnosis_default)
    this.pre_diagnosis_defaults.disable()
    this.getHospital_Package()
  }

  getHospital_Package(){
    this.http.get(this.hospitalAPI, this.httpOptions).subscribe(pre_diagnosis => {
      // console.log(pre_diagnosis['message']);
      pre_diagnosis['message'].forEach( (item, index) =>{
        if(item === 'Tuberculosis'){
          this.pre_diagnosis = pre_diagnosis['message'].splice(index,1);
        } 
        if(item === 'Abnormal'){
          this.pre_diagnosis = pre_diagnosis['message'].splice(index,1);
        } 
      })
      this.pre_diagnosis = pre_diagnosis['message']
      // console.log(this.pre_diagnosis);
      this.pre_diagnosis_selete.setValue(this.pre_diagnosis)
    })
  }

  submit(){
    // console.log(this.hospital_selete.value);
    // console.log(this.pre_diagnosis_selete.value);
    this.data = {
      hospital_selete : this.hospital_selete.value,
      pre_diagnosis_selete : this.pre_diagnosis_selete.value
    }
    console.log(this.data['pre_diagnosis_selete']);
    localStorage.setItem('pre_diagnosis_selete', JSON.stringify(this.data['pre_diagnosis_selete']))
    // this.route.navigate(['main/upload'])
    if (this.role == 'user') {
      this.router.navigate(['/main/upload']);
    }
    else if ((this.role == 'superadmin' || this.role == 'admin')) {
      this.router.navigate(['/main/mangement/employee']);
    } else {
      return
    }
  }

}
